import PageContainerInquiry from "./PageContainerInquiry";

export default PageContainerInquiry;
